<template>
    <b-col cols="12"
           lg="9"
           id="section_main"
           class="section-main">
        <check-fnwallet v-if="!hasPacket"></check-fnwallet>
        <futurocoins-from-mining v-if="hasPacket"></futurocoins-from-mining>
        <div class="marketing-plan-outer" v-if="isBanned">
            <marketing-plan-item v-for="(item, index) in items"
                                 :key="index"
                                 :label="item.label"
                                 :link="item.link"></marketing-plan-item>
        </div>
    </b-col>
</template>

<script>
    import CheckFnwallet from './dashboard/CheckFnwallet.vue'
    import FuturocoinsFromMining from './dashboard/FuturocoinsFromMining.vue'
    import MarketingPlanItem from './marketing-plan/MarketingPlanItem.vue'

    export default {
        components: { CheckFnwallet, FuturocoinsFromMining, MarketingPlanItem },
        data () {
            return {
                items: {
                    1: {
                        label: 'FuturoNetwork marketing plan EN',
                        link: 'https://download.futurenet.club/futuro/FuturoNetwork_MarketingPlan_(EN).pdf'
                    },
                    2: {
                        label: 'FuturoNetwork marketing plan PL',
                        link: 'https://download.futurenet.club/futuro/FuturoNetwork_MarketingPlan_(PL).pdf'
                    },
                    3: {
                        label: 'FuturoNetwork marketing plan CN',
                        link: 'https://download.futurenet.club/futuro/FuturoNetwork_MarketingPlan_(CN).pdf'
                    }
                }
            }
        },
        computed: {
            hasPacket () {
                return this.$store.getters.user.position != 0
            },
            isBanned () {
                const isBanned = this.$store.getters.isBanned;

                return (!isBanned && typeof isBanned !== 'object');
            }
        }
    }
</script>

<style lang="scss" scoped>
    .marketing-plan-outer{
        margin: 26px 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/partials/section/content/MarketingPlanContent.vue